import { UserRound } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface Props {
  source: "user" | "canonical" | "none" | undefined;
}

/**
 * Badge that signals whether the currently-viewed PDF is the user's private
 * upload (post-isolation) or a canonical open-access copy. Renders nothing
 * for canonical/none so the canonical case stays visually clean.
 */
export function PdfSourceIndicator({ source }: Props) {
  if (source !== "user") return null;
  return (
    <Badge
      variant="outline"
      className="shrink-0 gap-1 bg-blue-500/10 text-blue-700 border-blue-500/30 dark:text-blue-300 dark:bg-blue-500/15"
      title="This PDF is your uploaded copy. It is private to your account."
    >
      <UserRound className="size-3" aria-hidden="true" />
      Your uploaded copy
    </Badge>
  );
}
